import {Auth0LoginComponent} from './components/authentication/auth0-login.component';
import {Route, Router, Routes} from '@angular/router';
import {FullComponent} from './layouts/full/full.component';
import {ListingsComponent} from './components/objects/listings/listings.component';
import {DetailLoaderComponent} from './components/objects/detail-loader/detail-loader/detail-loader.component';
import {ConversationsComponent} from './components/conversations/conversations/conversations.component';
import {ConversationComponent} from './components/conversations/conversation/conversation.component';
import {ConversationVisualFixtureComponent} from './components/conversations/visual-fixture/conversation-visual-fixture.component';
import {conversationVisualFixtureCanMatch} from './components/conversations/visual-fixture/conversation-visual-fixture.guard';
import {ClientSettingsVisualFixtureComponent} from './components/client-settings/visual-fixture/client-settings-visual-fixture.component';
import {clientSettingsVisualFixtureCanMatch} from './components/client-settings/visual-fixture/client-settings-visual-fixture.guard';
import {OverallDashboardComponent} from "./components/dashboard/reports/overall-dashboard.components";
import {ProductCardAnalyticsComponent} from "./components/dashboard/product-card-analytics/product-card-analytics.component";
import {ProductCardAnalyticsVisualFixtureComponent} from './components/dashboard/product-card-analytics/product-card-analytics-visual-fixture.component';
import {
    productCardAnalyticsVisualFixtureCanMatch
} from './components/dashboard/product-card-analytics/product-card-analytics-visual-fixture.guard';
import {
    FrontendSettingsVisualFixtureComponent
} from './components/chatbots/settings/frontend-settings/frontend-settings-visual-fixture.component';
import {
    frontendSettingsVisualFixtureCanMatch
} from './components/chatbots/settings/frontend-settings/frontend-settings-visual-fixture.guard';
import {
    ChatbotSettingsVisualFixtureComponent
} from './components/chatbots/settings/chatbot-settings-visual-fixture.component';
import {
    chatbotSettingsVisualFixtureCanMatch
} from './components/chatbots/settings/chatbot-settings-visual-fixture.guard';
import {WidgetPreviewFixtureComponent} from './components/chatbots/widget-preview-fixture/widget-preview-fixture.component';
import {widgetPreviewFixtureCanMatch} from './components/chatbots/widget-preview-fixture/widget-preview-fixture.guard';
import {
    FunctionGeneralSettingsVisualFixtureComponent
} from './components/functions/function-settings/function-general-settings/function-general-settings-visual-fixture.component';
import {
    functionGeneralSettingsVisualFixtureCanMatch
} from './components/functions/function-settings/function-general-settings/function-general-settings-visual-fixture.guard';
import {
    FunctionWorkflowBindingSelectorVisualFixtureComponent
} from './components/functions/function-settings/function-workflow-binding-selector/function-workflow-binding-selector-visual-fixture.component';
import {
    functionWorkflowBindingSelectorVisualFixtureCanMatch
} from './components/functions/function-settings/function-workflow-binding-selector/function-workflow-binding-selector-visual-fixture.guard';
import {ChatbotVisualFixtureComponent} from './components/chatbots/visual-fixture/chatbot-visual-fixture.component';
import {chatbotVisualFixtureCanMatch} from './components/chatbots/visual-fixture/chatbot-visual-fixture.guard';
import {ListingsVisualFixtureComponent} from './components/objects/listings/visual-fixture/listings-visual-fixture.component';
import {listingsVisualFixtureCanMatch} from './components/objects/listings/visual-fixture/listings-visual-fixture.guard';
import {inject} from '@angular/core';
import {EnhancedMsalGuard} from './services/auth/msal/enhanced-msal.guard';
import {WebinarsAdminComponent} from './components/webinars/webinars-admin.component';
import {WebinarDetailPageComponent} from './components/webinars/webinar-detail-page/webinar-detail-page.component';
import {WebinarSeriesDetailComponent} from './components/webinars/webinar-series-detail/webinar-series-detail.component';
import {WebinarSettingsComponent} from './components/webinars/webinar-settings/webinar-settings.component';
import {WebinarsVisualFixtureComponent} from './components/webinars/visual-fixture/webinars-visual-fixture.component';
import {webinarsVisualFixtureCanMatch} from './components/webinars/visual-fixture/webinars-visual-fixture.guard';
import {ConnectConnectionsComponent} from './components/connect/connections/connect-connections.component';
import {ConnectSettingsComponent} from './components/connect/settings/connect-settings.component';
import {ConnectConnectionDetailComponent} from './components/connect/connections/connect-connection-detail.component';
import {DomainSettingsComponent} from './components/settings/domains/domain-settings.component';
import {ConnectWorkflowCanvasComponent} from './components/connect/workflows/connect-workflow-canvas.component';
import {
    connectWorkflowCanvasVisualFixtureCanMatch
} from './components/connect/workflows/connect-workflow-canvas-visual-fixture.guard';
import {
    connectWorkflowCanvasVisualFixtureProviders
} from './components/connect/workflows/connect-workflow-canvas-visual-fixture';
import {ConnectProviderDetailComponent} from './components/connect/settings/connect-provider-detail.component';
import {ConnectAuthCallbackComponent} from './components/connect/auth/connect-auth-callback.component';
import {ConnectRunsComponent} from './components/connect/workflows/connect-runs.component';
import {ConnectWorkflowsComponent} from './components/connect/workflows/connect-workflows.component';
import {ConnectNoviceLocalComponent} from './components/connect/novice/connect-novice-local.component';
import {ConnectGuidedWorkflowBuilderComponent} from './components/connect/guided/connect-guided-workflow-builder.component';
import {UserManagementComponent} from './components/settings/users/user-management.component';
import {
    userManagementVisualFixtureCanMatch
} from './components/settings/users/user-management-visual-fixture.guard';

// Import the actual Shine Enrich components
import {EnrichSettingsComponent} from './components/enrich/settings/settings.component';
import {FieldMappingComponent} from './components/enrich/mapping/mapping.component';
import {EnrichCompaniesComponent} from './components/enrich/companies/companies.component';
import {
    enrichCompanySearchVisualFixtureProviders,
} from './components/enrich/companies/companies-visual-fixture';
import {EnrichCompanyDetailComponent} from './components/enrich/companies/company-detail.component';
import {EnrichFiltersComponent} from './components/enrich/filters/filters.component';
import {EnrichFilterFormComponent} from './components/enrich/filters/filter-form.component';
import {EnrichSyncHistoryComponent} from './components/enrich/sync-history/sync-history.component';
import {EnrichSyncHistoryDetailComponent} from './components/enrich/sync-history/sync-history-detail.component';
import {EnrichSetupComponent} from './components/enrich/setup/setup.component';
import {EnrichVisualFixtureComponent} from './components/enrich/visual-fixture/enrich-visual-fixture.component';
import {enrichVisualFixtureCanMatch} from './components/enrich/visual-fixture/enrich-visual-fixture.guard';
import {EnrichRuntimeStatusComponent} from './components/enrich/runtime-status/runtime-status.component';
import {
    RuntimeStatusVisualFixtureComponent
} from './components/enrich/runtime-status/visual-fixture/runtime-status-visual-fixture.component';
import {
    runtimeStatusVisualFixtureCanMatch
} from './components/enrich/runtime-status/visual-fixture/runtime-status-visual-fixture.guard';
import {
    isEnrichRuntimeStatusSupported
} from './components/enrich/runtime-status/runtime-status-capability';
import {ProductFeedSettingsComponent} from './components/product-feeds/product-feeds-settings/product-feed-settings/product-feed-settings.component';
import {
    productFeedVisualFixtureCanMatch,
    productFeedVisualFixtureProviders
} from './components/product-feeds/product-feeds-settings/product-feed-settings/product-feed-settings.visual-fixture';
import {InterfaceLoadReproComponent} from './components/testing/interface-load-repro/interface-load-repro.component';
import {interfaceLoadVisualFixtureCanMatch} from './components/testing/interface-load-repro/interface-load-repro.guard';
import {ClientService} from './services/auth/client.service';
import {EnrichSetupGuard} from './guards/enrich-setup.guard';
import {ClientLoadGuard} from './guards/client-load.guard';
import {ProductLandingComponent} from './components/product-landing/product-landing.component';
import {ProductAccessGuard} from './guards/product-access.guard';
import {InternalAdminGuard} from './guards/internal-admin.guard';
import {TranslationsAdminComponent} from './components/translations/translations-admin.component';
import {PublicProductPageComponent} from './components/public-product-pages/public-product-page.component';
import {
    TranslationsVisualFixtureComponent
} from './components/translations/visual-fixture/translations-visual-fixture.component';
import {UserManagementAdminGuard} from './guards/user-management-admin.guard';
import {
    connectWorkflowVisualFixtureCanMatch,
    connectWorkflowVisualFixtureProviders
} from './components/connect/workflows/connect-workflow-visual-fixture';
import {
    translationsVisualFixtureCanMatch
} from './components/translations/visual-fixture/translations-visual-fixture.guard';
import {environment} from '../environments/environment';

export function buildEnrichRuntimeStatusRoute(environmentName: string): Route {
    if (!isEnrichRuntimeStatusSupported(environmentName)) {
        return {
            path: 'enrich/runtime-status',
            redirectTo: 'enrich/setup',
            pathMatch: 'full',
        };
    }

    return {
        path: 'enrich/runtime-status',
        component: EnrichRuntimeStatusComponent,
        canActivate: [ProductAccessGuard],
        data: {productType: 'Shine Enrich'},
    };
}

// Function to redirect based on available products
export const redirectToActiveProduct = () => {
  const clientService = inject(ClientService);
  const router = inject(Router);

  console.log('Redirecting based on available products...');

  // Check if client is loaded
  if (!clientService.client && clientService.clients.length === 0) {
    // If client is not loaded yet, refresh clients and use default route
    console.log('No client loaded, using default route');
    router.navigate(['/ai/dashboard']);
    return true;
  }

  // Define product priority (first is best)
    const productPriority = ['Shine Translations', 'Shine Webinars', 'Shine Connect', 'Shine AI', 'Shine Enrich'];

  // Get enabled products for the current client
  const enabledProducts = clientService.client?.enabledProducts || [];
  console.log(`Enabled product count for client: ${enabledProducts.length}`);

  // Find the first enabled product based on priority
  const firstBestProduct = productPriority.find(product => enabledProducts.includes(product));
  console.log('First best product:', firstBestProduct);

  // Redirect based on the first best product
    let targetRoute = '/ai/dashboard';
    switch (firstBestProduct) {
        case 'Shine Enrich':
            console.log('Redirecting to Shine Enrich');
            targetRoute = '/enrich/setup';
            break;
        case 'Shine Connect':
            console.log('Redirecting to Shine Connect');
            targetRoute = '/connect/workflows';
            break;
        case 'Shine Webinars':
            console.log('Redirecting to Shine Webinars');
            targetRoute = '/webinars';
            break;
        case 'Shine Translations':
            console.log('Redirecting to Shine Translations');
            targetRoute = '/translations';
            break;
        default:
            console.log('Redirecting to Shine AI dashboard');
            targetRoute = '/ai/dashboard';
            break;
    }

    router.navigate([targetRoute]);

  // Update the active product in the client service
  if (firstBestProduct) {
    clientService.setActiveProduct(firstBestProduct);
  }

  return true;
};

export const routes: Routes = [
    // OAuth popup callback page (posts a message to the opener and closes)
    {path: 'auth/callback', component: ConnectAuthCallbackComponent},
    ...(environment.authenticationProvider === 'auth0' ? [{path: 'authentication/login', component: Auth0LoginComponent}] : []),
    {
        path: 'connect/workflows/new',
        component: ConnectWorkflowCanvasComponent,
        canMatch: [connectWorkflowVisualFixtureCanMatch],
        providers: connectWorkflowVisualFixtureProviders,
        data: {fullWidth: true},
    },
    {
    path: '',
        redirectTo: '/ai/dashboard',
        pathMatch: 'full'
    },
    {
        path: 'products',
        redirectTo: '/products/ai',
        pathMatch: 'full'
    },
    {
        path: 'products/:slug',
        component: PublicProductPageComponent,
    },
    {
        path: 'enrich/setup',
        component: EnrichVisualFixtureComponent,
        canMatch: [enrichVisualFixtureCanMatch],
    },
    {
        path: 'enrich/companies',
        component: EnrichCompaniesComponent,
        canMatch: [enrichVisualFixtureCanMatch],
        providers: enrichCompanySearchVisualFixtureProviders,
    },
    {
        path: 'enrich/auth',
        component: EnrichVisualFixtureComponent,
        canMatch: [enrichVisualFixtureCanMatch],
    },
    {
        path: 'enrich/settings',
        component: EnrichVisualFixtureComponent,
        canMatch: [enrichVisualFixtureCanMatch],
    },
    {
        path: 'enrich/mapping',
        component: EnrichVisualFixtureComponent,
        canMatch: [enrichVisualFixtureCanMatch],
    },
    {
        path: 'enrich/runtime-status',
        component: RuntimeStatusVisualFixtureComponent,
        canMatch: [runtimeStatusVisualFixtureCanMatch],
    },
    {
        path: 'ai/data-feeds/:id',
        component: ProductFeedSettingsComponent,
        canMatch: [productFeedVisualFixtureCanMatch],
        providers: productFeedVisualFixtureProviders,
    },
    {
        path: 'ai/conversations',
        component: ConversationVisualFixtureComponent,
        canMatch: [conversationVisualFixtureCanMatch],
    },
    {
        path: 'ai/conversations/:id',
        component: ConversationVisualFixtureComponent,
        canMatch: [conversationVisualFixtureCanMatch],
    },
    {
        path: 'ai/product-card-analytics',
        component: ProductCardAnalyticsVisualFixtureComponent,
        canMatch: [productCardAnalyticsVisualFixtureCanMatch],
    },
    {
        path: 'ai/settings/frontend',
        component: FrontendSettingsVisualFixtureComponent,
        canMatch: [frontendSettingsVisualFixtureCanMatch],
    },
    {
        path: 'ai/settings/client-settings',
        component: ClientSettingsVisualFixtureComponent,
        canMatch: [clientSettingsVisualFixtureCanMatch],
    },
    {
        path: 'ai/functions/fixture',
        component: FunctionGeneralSettingsVisualFixtureComponent,
        canMatch: [functionGeneralSettingsVisualFixtureCanMatch],
    },
    {
        path: 'ai/functions/workflow-binding-fixture',
        component: FunctionWorkflowBindingSelectorVisualFixtureComponent,
        canMatch: [functionWorkflowBindingSelectorVisualFixtureCanMatch],
    },
    {
        path: 'ai/chatbots/widget-preview/product-card',
        component: WidgetPreviewFixtureComponent,
        canMatch: [widgetPreviewFixtureCanMatch],
    },
    {
        path: 'ai/assistants/fixture-base64',
        component: ListingsVisualFixtureComponent,
        canMatch: [listingsVisualFixtureCanMatch],
    },
    {
        path: 'ai/chatbots/:id',
        component: ChatbotSettingsVisualFixtureComponent,
        canMatch: [chatbotSettingsVisualFixtureCanMatch],
    },
    {
        path: 'ai/chatbots/:id',
        component: ChatbotVisualFixtureComponent,
        canMatch: [chatbotVisualFixtureCanMatch],
    },
    {
        path: 'webinars',
        component: WebinarsVisualFixtureComponent,
        canMatch: [webinarsVisualFixtureCanMatch],
    },
    {
        path: 'ai/dashboard',
        component: InterfaceLoadReproComponent,
        canMatch: [interfaceLoadVisualFixtureCanMatch],
        data: {fixtureTarget: 'dashboard'},
    },
    {
        path: 'ai/chatbots',
        component: InterfaceLoadReproComponent,
        canMatch: [interfaceLoadVisualFixtureCanMatch],
        data: {fixtureTarget: 'chatbots'},
    },
    {
        path: 'connect/workflows/review-fixture/:id/run/:runId',
        component: ConnectWorkflowCanvasComponent,
        canMatch: [connectWorkflowCanvasVisualFixtureCanMatch],
        providers: connectWorkflowCanvasVisualFixtureProviders,
        data: {fullWidth: true, visualFixtureSelectedNodeId: 'node-transform'},
    },
    {
        path: 'settings/users',
        component: UserManagementComponent,
        canMatch: [userManagementVisualFixtureCanMatch],
    },
    {
        path: 'translations',
        component: TranslationsVisualFixtureComponent,
        canMatch: [translationsVisualFixtureCanMatch],
    },
    {
        path: '',
        component: FullComponent, canActivate: [EnhancedMsalGuard, ClientLoadGuard], // Authenticate before loading tenant/client state.
        children: [
            {
                path: 'settings/users',
                component: UserManagementComponent,
                canActivate: [UserManagementAdminGuard],
            },
            {
                path: 'ai/dashboard',
                component: OverallDashboardComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine AI'}
            },
            {
                path: 'ai/product-card-analytics',
                component: ProductCardAnalyticsComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine AI'}
            },
      // Shine AI routes
            {
                path: 'ai/conversations',
                component: ConversationsComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine AI'}
            },
            {
                path: 'ai/conversations/:id',
                component: ConversationComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine AI'}
            },
            {
                path: 'ai/:type',
                component: ListingsComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine AI'}
            },
            {
                path: 'ai/:type/:id',
                component: DetailLoaderComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine AI'}
            },

            // Shine Connect routes
            {path: 'connect', redirectTo: 'connect/workflows', pathMatch: 'full'},

            // Shared connections (top-level)
            {
                path: 'connections',
                component: ConnectConnectionsComponent,
            },
            {
                path: 'connections/new',
                component: ConnectConnectionDetailComponent,
            },
            {
                path: 'connections/:id',
                component: ConnectConnectionDetailComponent,
            },
            {
                path: 'domains',
                component: DomainSettingsComponent,
                canActivate: [UserManagementAdminGuard],
            },

            {
                path: 'connect/workflows',
                component: ConnectNoviceLocalComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Connect'}
            },
            {
                path: 'connect/workflows/advanced',
                component: ConnectWorkflowsComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Connect'}
            },
            {
                path: 'connect/workflows/new',
                component: ConnectGuidedWorkflowBuilderComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Connect', fullWidth: true}
            },
            {
                path: 'connect/workflows/:id/guided',
                component: ConnectGuidedWorkflowBuilderComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Connect', fullWidth: true}
            },
            {path: 'connect/workflows/:id', redirectTo: 'connect/workflows/:id/edit', pathMatch: 'full'},
            {
                path: 'connect/workflows/:id/edit',
                component: ConnectWorkflowCanvasComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Connect', fullWidth: true}
            },
            {
                path: 'connect/workflows/:id/run/:runId',
                component: ConnectWorkflowCanvasComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Connect', fullWidth: true}
            },
            {
                path: 'connect/runs',
                component: ConnectRunsComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Connect'}
            },
            {
                path: 'connect/connections',
                redirectTo: '/connections',
                pathMatch: 'full'
            },
            {
                path: 'connect/connections/new',
                redirectTo: '/connections/new',
                pathMatch: 'full'
            },
            {
                path: 'connect/connections/:id',
                redirectTo: '/connections/:id',
                pathMatch: 'full'
            },
	            {
	                path: 'connect/settings/providers/new',
	                component: ConnectProviderDetailComponent,
	                canActivate: [InternalAdminGuard],
	                data: {productType: 'Shine Connect'}
	            },
	            {
	                path: 'connect/settings/providers/:id',
	                component: ConnectProviderDetailComponent,
	                canActivate: [InternalAdminGuard],
	                data: {productType: 'Shine Connect'}
	            },
	            {
	                path: 'connect/settings',
	                component: ConnectSettingsComponent,
	                canActivate: [InternalAdminGuard],
	                data: {productType: 'Shine Connect'}
	            },

      // Shine Enrich routes
      { path: 'enrich/auth', redirectTo: 'enrich/setup', pathMatch: 'full' },
      { path: 'enrich/setup', component: EnrichSetupComponent, canActivate: [ProductAccessGuard], data: {productType: 'Shine Enrich'} },
        buildEnrichRuntimeStatusRoute(environment.environment),
        {path: 'enrich/settings', component: EnrichSettingsComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/mapping', component: FieldMappingComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/companies/:orgNumber', component: EnrichCompanyDetailComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/companies', component: EnrichCompaniesComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/filters', component: EnrichFiltersComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/filters/new', component: EnrichFilterFormComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/filters/:id', component: EnrichFilterFormComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/sync-history', component: EnrichSyncHistoryComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},
        {path: 'enrich/sync-history/:id', component: EnrichSyncHistoryDetailComponent, canActivate: [ProductAccessGuard, EnrichSetupGuard], data: {productType: 'Shine Enrich'}},

            // Product landing pages for unavailable products
            {path: 'products/:product/landing', component: ProductLandingComponent, data: {fullWidth: true}},

            // Shine Webinars routes
            {
                path: 'webinars',
                component: WebinarsAdminComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Webinars'}
            },
            {
                path: 'webinars/settings',
                component: WebinarSettingsComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Webinars'}
            },
            {
                path: 'webinars/new',
                component: WebinarDetailPageComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Webinars'}
            },
            {
                path: 'webinars/series/:seriesId',
                component: WebinarSeriesDetailComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Webinars'}
            },
            {
                path: 'webinars/:id',
                component: WebinarDetailPageComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Webinars'}
            },
            {
                path: 'translations',
                component: TranslationsAdminComponent,
                canActivate: [ProductAccessGuard],
                data: {productType: 'Shine Translations'}
            },
    ]
  },
  { 
    path: '**',
      redirectTo: '/ai/dashboard'
  },
];
